import { render, staticRenderFns } from "./RelatorioFaturamentoList.vue?vue&type=template&id=4f252446&scoped=true"
import script from "./RelatorioFaturamentoList.vue?vue&type=script&lang=js"
export * from "./RelatorioFaturamentoList.vue?vue&type=script&lang=js"
import style0 from "./RelatorioFaturamentoList.vue?vue&type=style&index=0&id=4f252446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f252446",
  null
  
)

export default component.exports